import axios from "axios";
import { PromiseHandler } from "../../../handlers";
import { MadSDKAbortError, NotImplementedError } from "../../../errors";
import { DmpProvidersFetchFailed } from "./errors";
import { serviceDmpProviderInfoToDmpProviderInfo } from "../../../models/dataManagementPlatform/providers";
/**
 * Handler for DMP Providers
 * Provides basic provider information for all DMPs
 */
class DmpProviders extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "dmp-providers");
    }
    /**
     * Fetch DMP provider information from the dashboard endpoint
     * @returns Promise with array of DMP provider information
     */
    async findItems() {
        const url = `${this.sdk.urls.baseAPIUrl}/dmp-dashboard`;
        // Check cache first
        if (this.cache.has(url)) {
            return this.cache.get(url);
        }
        const req = new Promise((resolve, reject) => {
            axios
                .get(url)
                .then(({ data }) => {
                if (data.status === "OK" && data.data) {
                    // Convert from snake_case (service) to camelCase (frontend)
                    const providers = (data.data.providers || []).map(serviceDmpProviderInfoToDmpProviderInfo);
                    resolve(providers);
                }
                else if (data.errors && data.errors.length > 0) {
                    reject(new Error(data.errors.join(", ")));
                }
                else {
                    resolve([]);
                }
            })
                .catch((error) => {
                if (axios.isCancel(error)) {
                    reject(new MadSDKAbortError());
                }
                else {
                    reject(new DmpProvidersFetchFailed(error));
                }
            });
        });
        this.cache.set(url, req);
        return req;
    }
    // Not implemented - provider data is read-only
    async saveItem(_item) {
        throw new NotImplementedError("save");
    }
    // Not implemented - provider data is read-only
    async deleteItem(_id) {
        throw new NotImplementedError("delete");
    }
}
export default DmpProviders;
//# sourceMappingURL=index.js.map